// Single source of truth for category hero imagery across Bidorah.
// Landing, /categories, and the mobile navbar drawer all pull from here
// so a picture swap takes effect everywhere at once.
//
// ════════════════════════════════════════════════════════════════════
//  RULES FOR THIS FILE — DO NOT VIOLATE
// ════════════════════════════════════════════════════════════════════
//
//  1) NEVER use `customer-assets.emergentagent.com` URLs here.
//     Those URLs return 200 to curl but the Capacitor Android WebView
//     and several desktop browser configurations silently fail to render
//     them, leaving customers with broken-image icons across the
//     marketplace's most important visual surface. We have shipped
//     and rolled back this regression THREE times. Don't do it again.
//
//  2) Always self-host new images under `/app/frontend/public/categories/`
//     (referenced as `/categories/<file>.jpg`). Same-origin assets
//     have zero network/CSP/CORS variance and are bundled with every
//     deploy. To add an image:
//
//        - Drop the .jpg/.png file in /app/frontend/public/categories/
//        - Optimize to ≤ 900px wide, q=82, ≤ 200 KB
//        - Reference it as `/categories/<filename>` below
//
//  3) If you absolutely must use an external CDN (e.g. unsplash.com,
//     pexels.com), pick one of those two — they are the only external
//     CDNs verified to render reliably across desktop + iOS + Android
//     WebView + Capacitor APK.
//
//  4) The lint test in `tests/test_category_images_guardrail.py`
//     enforces rule (1). It will fail CI/preview tests if anyone
//     re-introduces a customer-assets.* URL here.
// ════════════════════════════════════════════════════════════════════

export const CATEGORY_IMAGES = {
  // Self-hosted user picks (bundled with the app, never break):
  "Luxury Bags & Accessories": "/categories/luxury-bags.jpg",
  "Trading Card Games": "/categories/trading-card-games.jpg",
  "Rocks & Crystals": "/categories/rocks-crystals.jpg",
  "Electronics": "/categories/electronics.jpg",
  "Storage Unit Finds": "/categories/storage-unit-finds.jpg",
  "Fragrances & Perfume": "/categories/fragrances-perfume.jpg",
  "Sports Cards": "/categories/sports-cards.jpg",
  "Plants": "/categories/plants.jpg",
  "Women's Apparel": "/categories/womens-apparel.jpg",
  "Jewelry": "/categories/jewelry.jpg",

  // External CDN-hosted (verified to render in every WebView build):
  "Sneakers":
    "https://images.pexels.com/photos/16304369/pexels-photo-16304369.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "Funko":
    "https://images.unsplash.com/photo-1608889335941-32ac5f2041b9?auto=format&fit=crop&w=900&q=80",
};

// Defensive fallback used by Landing/Categories/Navbar when an image fails
// to load (rare, but possible if a CDN burps). Always points to a
// guaranteed-good self-hosted asset so customers NEVER see a broken icon.
export const CATEGORY_FALLBACK_IMAGE = "/categories/luxury-bags.jpg";

export const getCategoryImage = (name) =>
  CATEGORY_IMAGES[name] || CATEGORY_FALLBACK_IMAGE;
